import "./footer.css";
import { useState } from "react";

const Footer = () => {
  let [email, setemail] = useState();
  const CONTACT_NUMBER = '0113899836';

  return (
    <footer>
      <div className="container">
        <div className="row justify-content-center pt-5 pb-3">
          <div className="col-12 col-lg-6 d-flex my-0 my-lg-3 mb-4 mb-lg-0">
            <div className="w-100 text-center">
              <h4>Think Twice Second Hand Clothes</h4>
              
              <div className="contact-section mt-4 mb-4">
                <h6 className="mb-2">Contact Us</h6>
                <a href={`tel:${CONTACT_NUMBER}`} className="contact-link">
                  <i className="bi bi-telephone-fill me-2"></i>
                  {CONTACT_NUMBER}
                </a>
              </div>

              <div className="physical-shops mt-4 mb-4">
                <h6 className="mb-3">Visit Our Physical Shops</h6>
                <div className="shop-locations">
                  <p className="shop-location">📍 Karatina, Nyeri</p>
                  <p className="shop-location">📍 Nyeri Town</p>
                  <p className="shop-location">📍 Kitengela</p>
                  <p className="shop-location">📍 Utawala, Nairobi</p>
                  <p className="shop-location">📍 Nairobi CBD</p>
                  <p className="shop-location">📍 Mombasa</p>
                  <p className="shop-location">📍 Kisumu</p>
                  <p className="shop-location">📍 Embu</p>
                </div>
              </div>

              <h6 className="mb-3 mt-4">Subscribe</h6>
              <div>
                <p>Get 10% off your first order</p>
                <form action="#" className="d-flex gap-1 py-1 justify-content-center">
                  <input
                    type="email"
                    placeholder="Enter your email"
                    className="ps-2"
                    onChange={(e) => {
                      setemail(e.target.value);
                    }}
                    value={email}
                  />
                  <button
                    type="submit"
                    className="d-flex align-items-center"
                  >
                    <ion-icon name="send-outline"></ion-icon>
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="socket text-center py-3">
        <p className="m-0">
          &copy; {new Date().getFullYear()} Think Twice Second Hand Clothes. All Rights Reserved.
        </p>
      </div>
    </footer >
  );
};

export default Footer;
